// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1uU_7","list":"styles_list__2TGr7"};